import React, { useState } from 'react'
import Button, { ButtonVariants } from './Button'
import HomeIcon from '@mortgage-pos/ui/assets/house.svg'
import ContactIcon from '@mortgage-pos/ui/assets/profile.svg'
import DocumentIcon from '@mortgage-pos/ui/assets/Summary_Declarations_Icon.svg'
import AmazonA from '@mortgage-pos/ui/assets/amazon-benefits.png'
import SageLogo from '@mortgage-pos/ui/assets/sageHomeLoansLogo.svg'
import { useStoreActions } from '../store'

const wait = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms))

export const AmazonBenefits: React.FC = () => {
  const [isFetching, setIsFetching] = useState(false)
  const { next } = useStoreActions((store) => store.questionnaire)
  const { setAnswers } = useStoreActions((store) => store.answers)

  const importClickHandler = async () => {
    setIsFetching(true)
    await wait(5000)

    setAnswers({
      yearBuilt: 451, // RSU
      grossAnnualIncome: 240000,
      createAccount: [
        {
          email: `montyburns.${Math.floor(Math.random() * 3000) + 1}@gmail.com`,
        },
      ],
      lastFourPhone: '1823', // SSN last 4 in the demo
      phone: '6365550113',
    })

    setIsFetching(false)

    next()
  }

  if (isFetching) {
    return <AmazonToSageLoader />
  }

  return (
    <div className="amazon-benefits">
      <div className="amazon-benefits__trait-container">
        <div className="amazon-benefits__trait-list">
          <div className="amazon-benefits__trait-item">
            <img
              src={HomeIcon}
              alt="Home Icon"
              className="amazon-benefits__trait-icon"
            />
            <span className="amazon-benefits__trait-label">
              Current location and mailing address.
            </span>
          </div>
          <div className="amazon-benefits__trait-item">
            <img
              src={ContactIcon}
              alt="Contact Icon"
              className="amazon-benefits__trait-icon"
            />
            <span className="amazon-benefits__trait-label">
              Contact information.
            </span>
          </div>
          <div className="amazon-benefits__trait-item">
            <img
              src={DocumentIcon}
              alt="Document Icon"
              className="amazon-benefits__trait-icon"
            />
            <span className="amazon-benefits__trait-label">
              Income and RSUs.
            </span>
          </div>
        </div>
      </div>
      <Button
        className="amazon-benefits__cta-button"
        onClick={importClickHandler}
        variant={ButtonVariants.next}
        content="Import my Amazon info and prefill application"
      />
      <div className="amazon-benefits__disclaimer">
        By clicking "Import my Amazon info and prefill application", you consent
        to Sage Home Loans pulling verified third party data from Amazon.
      </div>
      <div className="amazon-benefits__horizontal-divider" />
      <Button
        className="amazon-benefits__skip-button"
        type="submit"
        variant={ButtonVariants.skip}
        content="I'll enter everything myself manually"
      />
    </div>
  )
}

const AmazonToSageLoader = () => {
  return (
    <div className="amazon-to-sage-loader">
      <div className={'amazon-to-sage-loader__container is-animating'}>
        <img
          src={AmazonA}
          alt="Amazon Logo"
          className="amazon-to-sage-loader__logo amazon-to-sage-loader__logo--amazon"
        />
        <div style={{ display: 'flex', gap: '12px' }}>
          <div className="amazon-to-sage-loader__transfer-dots --second" />
          <div className="amazon-to-sage-loader__transfer-dots --fourth" />
          <div className="amazon-to-sage-loader__transfer-dots --first" />
          <div className="amazon-to-sage-loader__transfer-dots --fifth" />
          <div className="amazon-to-sage-loader__transfer-dots --third" />
        </div>
        <img
          src={SageLogo}
          alt="Sage Logo"
          className="amazon-to-sage-loader__logo amazon-to-sage-loader__logo--sage"
        />
      </div>
    </div>
  )
}
